// Map of page names to actual routes
const PAGE_ROUTE_MAP: Record<string, string> = {
  // Admin routes
  'AdminDashboard': '/dashboard/admin',
  'Admin': '/admin',
  'AdminVerificationQueue': '/admin/verification-queue',
  'AdminRoles': '/admin/roles',
  'AdminTools': '/admin/tools',
  
  // General routes
  'Dashboard': '/dashboard',
  'MyProfile': '/profile',
  
  // Vikar routes
  'FindVagter': '/find-vagter',
  'MineVagter': '/mine-vagter',
  'MyTimesheets': '/my-timesheets',
  'MineLonsedler': '/mine-lonsedler',
  'VikarProfile': '/profile',
  'GDPRSettings': '/vikar/gdpr',
  
  // Kommune routes
  'AuditTrail': '/kommune/audit-trail',
  'StaffingRequestTemplates': '/kommune/skabeloner',
  
  // Cases / sager
  'SocialCases': '/sager',
  'AdminCases': '/admin/sager',

  // Keep default behavior for unmapped pages
};

export function createPageUrl(pageName: string): string {
  // Check if we have a specific mapping
  if (PAGE_ROUTE_MAP[pageName]) {
    return PAGE_ROUTE_MAP[pageName];
  }
  
  // Default: convert to lowercase with dashes
  return '/' + pageName.toLowerCase().replace(/ /g, '-');
}